import type { writeCommitFile } from "../commitFiles";
import { zql } from "../generatedDrizzleSchema";
import { escapeLikePattern } from "../likePattern";
import {
  STEP_TEST_CASES_DIR,
  STEP_TEST_CLOCK_SUFFIX,
} from "../stepTests/constants";
import { STEP_TEST_REQUESTS_SUFFIX } from "../stepTests/requests";
import { volumeFixtureBaseRelPath } from "../stepTests/volumes";

type StepTestFileTx = Parameters<typeof writeCommitFile>[0]["tx"];

export async function deleteStepTestVolumeFixtureFiles({
  tx,
  commitId,
  stepDir,
  name,
}: {
  tx: StepTestFileTx;
  commitId: string;
  stepDir: string;
  name: string;
}) {
  const prefix = `${stepDir}/${volumeFixtureBaseRelPath(name)}/`;
  const files = await tx.run(
    zql.commitFiles
      .where("commitId", commitId)
      .where("path", "LIKE", `${escapeLikePattern(prefix)}%`)
  );
  for (const file of files) {
    await tx.mutate.commitFiles.delete({ commitId, path: file.path });
  }
}

export async function deleteStepTestClockFile({
  tx,
  commitId,
  stepDir,
  name,
}: {
  tx: StepTestFileTx;
  commitId: string;
  stepDir: string;
  name: string;
}) {
  const clockPath = `${stepDir}/${STEP_TEST_CASES_DIR}/${name}${STEP_TEST_CLOCK_SUFFIX}`;
  const [clockFile] = await tx.run(
    zql.commitFiles.where("commitId", commitId).where("path", clockPath)
  );
  if (clockFile) {
    await tx.mutate.commitFiles.delete({ commitId, path: clockPath });
  }
}

export async function deleteStepTestRequestsFile({
  tx,
  commitId,
  stepDir,
  name,
}: {
  tx: StepTestFileTx;
  commitId: string;
  stepDir: string;
  name: string;
}) {
  const requestsPath = `${stepDir}/${STEP_TEST_CASES_DIR}/${name}${STEP_TEST_REQUESTS_SUFFIX}`;
  const [requestsFile] = await tx.run(
    zql.commitFiles.where("commitId", commitId).where("path", requestsPath)
  );
  if (requestsFile) {
    await tx.mutate.commitFiles.delete({ commitId, path: requestsPath });
  }
}
